const API_PATH_PREFIXES = [
  "/api/",
  "/auth/",
  "/admin/",
  "/storefront/",
  "/products",
  "/cart",
  "/orders",
  "/inquiries",
  "/company/faq/"
];

function isApiLikePath(pathname) {
  const normalizedPath = String(pathname || "").trim().toLowerCase();
  if (!normalizedPath) {
    return false;
  }

  return API_PATH_PREFIXES.some((prefix) => normalizedPath === prefix.slice(0, -1) || normalizedPath.startsWith(prefix));
}

function toUrl(input) {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    if (input instanceof Request) {
      return new URL(input.url, window.location.origin);
    }

    return new URL(String(input || ""), window.location.origin);
  } catch {
    return null;
  }
}

function isApiRequest(input, init) {
  const url = toUrl(input);
  if (!url) {
    return false;
  }

  const sameOrigin = url.origin === window.location.origin;
  if (!sameOrigin) {
    return false;
  }

  if (isApiLikePath(url.pathname)) {
    return true;
  }

  const request = input instanceof Request ? input : null;
  const acceptHeader = request?.headers?.get("Accept") || init?.headers?.Accept || init?.headers?.accept || "";
  return /application\/json/i.test(String(acceptHeader || ""));
}

function buildHtmlFallbackResponse(input, response) {
  const url = toUrl(input);
  const requestUrl = url ? `${url.pathname}${url.search}` : String(input?.url || input || "");
  const payload = {
    message: "The API returned HTML instead of JSON.",
    code: "HTML_RESPONSE",
    url: requestUrl,
    status: response.status || 502
  };

  return new Response(JSON.stringify(payload), {
    status: response.status >= 400 ? response.status : 502,
    statusText: response.statusText || "Unexpected HTML Response",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-FT-Fetch-Guard": "html-response"
    }
  });
}

export default function apiResponseGuard() {
  if (typeof window === "undefined" || typeof window.fetch !== "function") {
    return;
  }

  if (window.__ftApiResponseGuardInstalled) {
    return;
  }

  const nativeFetch = window.fetch.bind(window);

  window.fetch = async (input, init) => {
    const response = await nativeFetch(input, init);

    if (!isApiRequest(input, init)) {
      return response;
    }

    const contentType = String(response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("text/html")) {
      return response;
    }

    console.error("Unexpected HTML response intercepted for API request", {
      url: toUrl(input)?.toString() || String(input?.url || input || ""),
      status: response.status,
      contentType
    });

    return buildHtmlFallbackResponse(input, response);
  };

  window.__ftApiResponseGuardInstalled = true;
}